<template>
  <div class="uploadAttachments">
    <div class="fujian-handler-box">
      <span class="fujian-handler" @click="handleUploadAppendFile()"
        ><i class="iconfont iconshangchuanfujian1"></i>点击上传</span
      >
      <span v-show="!fileName" class="fujian-handler-describe" :class="noAllow ? 'no-allow' : ''">上传文件大小不得超过30M。</span>
    </div>
    <div class="fujian-name-box" v-show="fileName">
      <span class="fujian-name">{{ fileName }}</span>
      <i
        
        @click="handleDeleteAppendFile()"
      >x</i>
    </div>
    <input
      type="file"
      ref="inputFile"
      v-show="false"
      @change="(e) => handleFileInputChange(e)"
      class="file-input"
    />
  </div>
</template>

<script>
import { uploadFile } from "@/api/Sys";
export default {
  data() {
    return {
      noAllow: false
    };
  },
  props: {
    fileName: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleUploadAppendFile() {
      const fileDom = this.$refs["inputFile"];
      fileDom.value = "";
      fileDom.click();
    },
    handleDeleteAppendFile() {
      this.$emit("deleteFile");
    },
    handleFileInputChange(event) {
      if (event.target && event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0];
        if (30*1024*1024 < file.size) {
          // this.$message.warning("文件大小不能超过30M，请重新选择！")
          this.noAllow = true
          return
        }
        this.noAllow = false
        // 30*1024*1024
        let formData = new FormData();
        formData.append("file", file);
        uploadFile(formData)
          .then((res) => {
            console.log(res)
            if (res.code === 200) {
              const obj = {
                reourceAddress: res.data.url,
                fileName: res.data.name
              }
              this.$emit("createFile", obj);
            }
            // if (res) {
            //   const obj = {
            //     reourceAddress: res.reourceAddress,
            //     fileName: file.name,
            //   };
            //   this.$emit("createFile", obj);
            // }
          })
          .catch(() => {
            this.$emit("deleteFile");
          });
      }
    },
  },
};
</script>

<style lang="scss">
.uploadAttachments {
  display: flex;
  padding-bottom: 16px;
  .fujian-name-box {
    cursor: pointer;
    display: flex;
    align-items: center;
    color: #666;
    &:hover {
      color: #2389e8;
      .fujian-handler-delete {
        color: #2389e8;
      }
    }
  }
  .fujian-name {
    margin-right: 5px;
    font-size: 14px;
    text-decoration: underline;

    .fujian-handler-delete {
      width: 14px;
      height: 14px;
      margin-left: 8px;
      cursor: pointer;
    }
  }
  .fujian-class {
    text-decoration: underline;
    cursor: pointer;
    color: #2389e8;
  }
  .fujian-handler-box {
    display: flex;
    align-items: center;
    .fujian-handler-describe {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #cccccc;
    }
    .no-allow {
      color: rgba(250, 80, 20, 1) !important;
    }
    i {
      font-size: 12px;
    }
  }
  .fujian-handler {
    width: 100px;
    box-sizing: border-box;
    height: 32px;
    border-radius: 4px;
    border: 1px solid #2389e8;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #2389e8;
    line-height: 32px;
    text-align: center;
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    i {
      margin-right: 4px;
    }
  }

  .fujian-box {
    .el-form-item__content {
      text-align: left;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/UploadAttachments/index.vue